import { createAsyncThunk } from "@reduxjs/toolkit";
import { createGraphQLThunk, createMultipartGraphQLThunk } from ".";
import { ADD_INVENTORY, CANCELLATION_POLICY, GET_INVENTORY_DETAILS, GET_SUPPLIERS, RETURN_POLICY, SAVE_CANCELLATION_POLICY, SAVE_RETURN_POLICY, UPDATE_CANCELLATION_POLICY, UPDATE_INVENTORY, UPDATE_RETURN_POLICY, VENDOR_STORES } from "../../utils/queries";

export const vendorStoresThunk = createAsyncThunk(
  "vendorStoresSlice/vendorStoresThunk",
  createGraphQLThunk({
    query: VENDOR_STORES,
    responseKey: "getInventoryIds",
    notError: true
  })
);

export const GetInventoryDetails = createAsyncThunk(
  "inventoryDetailsSlice/GetInventoryDetails",
  createGraphQLThunk({
    query: GET_INVENTORY_DETAILS,
    getVariables: (inventoryId) => (inventoryId),
    responseKey: "getInventory",
    notError: true
  })
);

export const GetReturnPolicy = createAsyncThunk(
  "returnPolicySlice/GetReturnPolicy",
  createGraphQLThunk({
    query: RETURN_POLICY,
    getVariables: (inventoryId) => (inventoryId),
    responseKey: "getReturnPolicy",
    notError: true
  })
);

export const GetCancellationPolicy = createAsyncThunk(
  "cancellationPolicySlice/GetCancellationPolicy",
  createGraphQLThunk({
    query: CANCELLATION_POLICY,
    getVariables: (inventoryId) => (inventoryId),
    responseKey: "getCancellationPolicy",
    notError: true
  })
);

export const GetSuppliers = createAsyncThunk(
  "suppliersSlice/GetSuppliers",
  createGraphQLThunk({
    query: GET_SUPPLIERS,
    getVariables: (productDomain) => (productDomain),
    responseKey: "getAllSuppliers",
  })
);

export const UpdateReturnPolicy = createAsyncThunk(
  "updateReturnPolicySlice/UpdateReturnPolicy",
  createGraphQLThunk({
    query: UPDATE_RETURN_POLICY,
    getVariables: (payload) => (payload),
    responseKey: "updateReturnPolicy",
    onSuccessMessage: "Return and Exchange Updated Successfully!"
  })
);

export const SaveReturnPolicy = createAsyncThunk(
  "saveReturnPolicySlice/SaveReturnPolicy",
  createGraphQLThunk({
    query: SAVE_RETURN_POLICY,
    getVariables: (payload) => (payload),
    responseKey: "saveReturnPolicy",
    onSuccessMessage: "Return and Exchange Saved Successfully!"
  })
);

export const UpdateCancellationPolicy = createAsyncThunk(
  "updateCancellationPolicySlice/UpdateCancellationPolicy",
  createGraphQLThunk({
    query: UPDATE_CANCELLATION_POLICY,
    getVariables: (payload) => (payload),
    responseKey: "updateCancellationPolicy",
    onSuccessMessage: "Cancellation Policy Updated Successfully!"
  })
);

export const SaveCancellationPolicy = createAsyncThunk(
  "saveCancellationPolicySlice/SaveCancellationPolicy",
  createGraphQLThunk({
    query: SAVE_CANCELLATION_POLICY,
    getVariables: (payload) => (payload),
    responseKey: "saveCancellationPolicy",
    onSuccessMessage: "Cancellation Policy Saved Successfully!"
  })
);

export const UpdateInventory = createAsyncThunk(
  "updateInventorySlice/UpdateInventory",
  createMultipartGraphQLThunk({
    query: UPDATE_INVENTORY,
    fileKeys: ["payload.logo", "payload.gstDoc.file", "payload.panDoc.file","payload.digitalSignature", "payload.licenseRequest[].file.file"],
    getVariables: (payload) => (payload),
    responseKey: "updateInventory",
    onSuccessMessage: "Store Details Updated Successfully!"
  })
);

export const AddInventory = createAsyncThunk(
  "addInventorySlice/AddInventory",
  createMultipartGraphQLThunk({
    query: ADD_INVENTORY,
    fileKeys: ["payload.logo", "payload.gstDoc.file", "payload.digitalSignature","payload.panDoc.file", "payload.licenseRequest[].file.file"],
    getVariables: ({payload}) => ({payload}),
    responseKey: "addInventory",
    onSuccessMessage: "Store Details Added Successfully!"
  })
);